const csrfToken = document
  .querySelector('meta[name="csrf"]')
  .getAttribute('content');

/**
 * Async script load
 * @param {URL} url
 */
export function loadScript(url) {
  return new Promise((resolve, reject) => {
    const script = document.createElement('script');
    script.src = url;
    script.async = true;
    script.onload = resolve;
    script.onerror = reject;
    document.body.appendChild(script);
  });
}

export function html([first, ...strings], ...values) {
  // Weave the literal strings and the interpolations.
  // We don't have to explicitly handle array-typed values
  // because concat will spread them flat for us.
  return values
    .reduce((acc, cur) => acc.concat(cur, strings.shift()), [first])
    .filter(Boolean)
    .join('');
}

/**
 * Preload an image
 * @param {URL} url - The image URL
 */
export function preloadImage(url) {
  return new Promise((resolve, reject) => {
    const image = new Image();
    image.src = url;
    image.onload = () => resolve(image);
    image.onerror = () => reject(new Error('Could not load image at ' + url));
  });
}

/**
 * Handles errors for fetch requests
 * @param {Object} response
 */

export function handleErrors(response) {
  if (!response.ok) throw Error(response.statusText);
  return response;
}

/**
 * Data loader, GET by default
 * @param {URL} url - The url
 * @param {JSON} [body] - Optional POST data
 * @returns {Promise}
 */
export async function load(url, body) {
  const headers = new Headers({
    'X-Requested-With': 'XMLHttpRequest',
  });

  const options = {
    credentials: 'include',
    headers,
  };

  if (typeof body === 'object') {
    headers.set('X-CSRFToken', csrfToken);
    headers.set('Content-Type', 'application/json');
    options.method = 'POST';
    options.body = JSON.stringify(body);
  }

  const response = await fetch(url, options);
  const type = response.headers.get('Content-Type');
  const parsed = type.includes('json')
    ? await response.json()
    : await response.text();

  if (response.ok) {
    return parsed;
  }
  throw new Error(parsed.message);
}

/**
 * Remove element
 * @param {HTMLElement} el
 */
export function removeElement(el) {
  el.parentNode.removeChild(el);
}

/**
 * Create HTML Fragment from a html string
 * @param {String} html - A snippet of HTML
 * @returns {DocumentFragment}
 */
export function createFragment(html) {
  return document.createRange().createContextualFragment(html);
}

/**
 * A Promise wrapper for requestAnimationFrame
 */
export function rafPromise() {
  return new Promise(requestAnimationFrame);
}

/**
 * Used for detecting when an element is rendered
 * @param {Node} element - The element that is waiting to be rendered
 */
export async function render(element) {
  element.getBoundingClientRect();
  const f1 = await rafPromise();
  const f2 = await rafPromise();
  return f2 - f1;
}

/**
 * Generic 'run once'
 * @param {Node} element - Element
 * @param {Event} event - Event to listen
 */

export function listenOnce(element, ...events) {
  return new Promise(resolve => {
    const onEvent = event => {
      resolve(event);
      element.removeEventListener(event, onEvent);
    };
    events.forEach(event => {
      element.addEventListener(event, onEvent);
    });
  });
}

/** Duh. */
export function isFunction(x) {
  return typeof x === 'function';
}



// WEBPACK FOOTER //
// ./src/js/utils.js